// extracted by mini-css-extract-plugin
export var breadcrumb = "Breadcrumb-module--breadcrumb--f9890";
export var breadcrumbs = "Breadcrumb-module--breadcrumbs--03d16";
export var light = "Breadcrumb-module--light--da334";